import { useParams } from 'react-router-dom';
import PinFormComponent from './PinForm';
import React from 'react';

export default function EditPins() {
  let { id } = useParams();
  return <PinFormComponent id={id} />;
}
